module.exports = __webpack_public_path__ + "img/Other4.a9066b76.svg";